import React from "react";
import { Card, Badge } from "react-bootstrap";

/**
 * Props:
 * - children: The content to display in the card
 * - chartData: The chart data to display
 * - lastRecordDateData: The Last Computation date data to display
 * - badgeColor: Optional color for the badge. Defaults to "warning" (orange)
 */
const EmptyCard = ({
  children,
  chartData,
  lastRecordDateData,
  badgeColor = "warning",
}) => {
  const renderDate = (date) => {
    if (!date) return null;

    // Return the appropriate date format for variation analysis
    const parseBetweenDates = (dateStr) => {
      if (!dateStr) return null;

      const matches = dateStr.match(/Between\s+(\S+)\s+and\s+(\S+)/);
      if (matches) {
        return `${matches[1]}|${matches[2]}`;
      }
      return dateStr;
    };

    // Variation analysis date format
    if (date.includes("and")) {
      date = parseBetweenDates(date);
      const [date1, date2] = date.split("|");
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span>Between</span>
          <Badge bg="warning">{date1}</Badge>
          <span>and</span>
          <Badge bg="info">{date2}</Badge>
        </div>
      );
    }

    return (
      <Badge
        className="mx-auto"
        bg={badgeColor}
        style={{ visibility: date ? "visible" : "hidden" }}
      >
        {date || "placeholder"}
      </Badge>
    );
  };

  if (chartData) {
    const { Amount, Title, Date } = chartData;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return (
      <Card className="h-100" style={{ boxShadow: "none" }}>
        <Card.Body className="py-3 text-center d-flex flex-column justify-content-center">
          <div className="fw-medium fs-8">{formatter.format(Amount)}</div>
          <div className="text-muted mb-2">{Title}</div>
          {renderDate(Date)}
        </Card.Body>
      </Card>
    );
  }

  if (lastRecordDateData && lastRecordDateData.length > 0) {
    const { Title } = lastRecordDateData[0];
    return (
      <Card className="h-100" style={{ boxShadow: "none" }}>
        <Card.Body className="py-2 text-center">
          <div className="text-muted fs-7">{Title}</div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Body className="py-1">
        <h3 className="text-center m-0 fs-5">{children}</h3>
      </Card.Body>
    </Card>
  );
};

export default EmptyCard;
